export const Api = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="16" cy="16" r="5" stroke="currentColor" stroke-width="2"/>
  <circle cx="26" cy="6" r="3" stroke="currentColor" stroke-width="2"/>
  <circle cx="6" cy="6" r="3" stroke="currentColor" stroke-width="2"/>
  <circle cx="26" cy="26" r="3" stroke="currentColor" stroke-width="2"/>
  <circle cx="6" cy="26" r="3" stroke="currentColor" stroke-width="2"/>
  <path d="M24 24L19.5 19.5" stroke="currentColor" stroke-width="2"/>
  <path d="M12.5 12.5L8 8" stroke="currentColor" stroke-width="2"/>
  <path d="M24 8L19.5 12.5" stroke="currentColor" stroke-width="2"/>
  <path d="M12.5 19.5L8 24" stroke="currentColor" stroke-width="2"/>
</svg>`;
